import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/userSlice";
import { Link } from "react-router-dom";

const Navbar = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const logoutHandler = (e) => {
    e.preventDefault();

    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    dispatch(logout(null));
  };

  return (
    <div className="bg-gray-500 text-white w-full p-5 flex justify-between">
      <div>
        <Link to="/">Upload Images</Link>
      </div>

      <div>
        {user && localStorage.getItem("token") ? (
          <button onClick={logoutHandler}>Logout</button>
        ) : (
          <Link to="/login">Login</Link>
        )}
      </div>
    </div>
  );
};

export default Navbar;
